import React from 'react';
import {
    Clock,
    Globe,
    ArrowRight,
    PlayCircle,
    LockOpen,
    TrendingUp,
} from 'lucide-react';
import {useNavigate} from "react-router-dom";

const Hero = () => {
    const navigate = useNavigate();
    return (
        <div className="relative w-full min-h-[100dvh] lg:min-h-screen overflow-hidden font-poppins selection:bg-primary/30 flex flex-col justify-center">

            {/* Grid Overlay */}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:25px_25px] sm:bg-[size:35px_35px] md:bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_60%_60%_at_50%_10%,#000_70%,transparent_100%)] pointer-events-none"></div>

            {/* Glows */}
            {/*<div className="absolute -top-20 -right-20 w-[250px] sm:w-[400px] md:w-[550px] h-[250px] sm:h-[400px] md:h-[550px] bg-primary/10 rounded-full blur-[80px] sm:blur-[90px] md:blur-[110px] opacity-30 md:opacity-40 pointer-events-none" />*/}
            {/*<div className="absolute bottom-0 -left-[15%] w-[200px] sm:w-[350px] md:w-[500px] h-[200px] sm:h-[350px] md:h-[500px] bg-secondary/10 rounded-full blur-[70px] md:blur-[100px] opacity-40 md:opacity-50 pointer-events-none" />*/}

            {/* Main Container */}
            {/*
                FIX 1: Adjusted Widths
                - md:w-[90%] (was 85%): Gives more room on tablets.
                - lg:w-[92%] (was 78%): CRITICAL FIX. 78% was too narrow for 2 columns on 1024px screens.
                - xl:w-[80%] (was 72%): Smooth stepping for larger screens.
            */}
            <div className="relative z-10 mx-auto w-[92%] sm:w-[88%] md:w-[90%] lg:w-[92%] xl:w-[80%] 2xl:w-[72%] pt-28 sm:pt-32 lg:pt-36 pb-12 lg:pb-20">

                <div className="grid lg:grid-cols-2 gap-10 lg:gap-8 xl:gap-16 items-center">

                    {/* LEFT COL */}
                    <div className="space-y-6 sm:space-y-8 order-1">

                        {/* Trust Badge */}
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full bg-white/60 dark:bg-bg-dark-2/80 border border-gray-200 dark:border-gray-800 backdrop-blur-sm shadow-xl">
                            <Globe className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary" />
                            <span className="text-[10px] sm:text-xs font-semibold tracking-wide text-gray-600 dark:text-gray-300 uppercase">
                                UAE-Based Market Intelligence
                            </span>
                        </div>

                        {/* Headline */}
                        {/* Adjusted clamp slightly to ensure it doesn't overflow on small tablets */}
                        <h1 className="font-bold text-dark dark:text-light leading-[1.15] tracking-tight text-[clamp(2.2rem,5vw,4.5rem)]">
                            We Don’t Follow <br className="hidden sm:block" />
                            the Market. <br />
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-[#0074BD] to-secondary">
                                We Forecast It.
                            </span>
                        </h1>

                        {/* Pill Indicators */}
                        <div className="flex flex-wrap items-center gap-2 sm:gap-3 text-xs sm:text-sm font-medium text-primary/90 uppercase tracking-wider">
                            <span>Time Technique Trading</span>
                            <span className="hidden sm:block w-1 h-1 rounded-full bg-gray-400 dark:bg-gray-600" />
                            <span className="hidden sm:block">Astro Techniques</span>
                            <span className="hidden sm:block w-1 h-1 rounded-full bg-gray-400 dark:bg-gray-600" />
                            <span>Institutional Cycles</span>
                        </div>

                        {/* Description */}
                        <p className="text-gray-600 dark:text-gray-400 text-base sm:text-lg leading-relaxed max-w-xl border-l-2 border-gray-300 dark:border-gray-700 pl-4 sm:pl-6">
                            The Only UAE-Based Market Intelligence Firm That trades the future — not the past.
                            <br />
                            <span className="text-dark dark:text-light italic block mt-3">
                                "If the world follows indicators, we follow Time itself."
                            </span>
                        </p>

                        {/* Anti-Indicator */}
                        <div className="bg-white/40 dark:bg-bg-dark-2/40 border border-gray-200 dark:border-gray-800 p-3 sm:p-4 rounded-lg backdrop-blur-md w-full sm:w-auto">
                            <p className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mb-2 uppercase tracking-wide font-bold">
                                Pure Time-Based Precision
                            </p>
                            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 sm:gap-6 text-xs sm:text-sm font-medium">
                                {['No RSI', 'No EMA', 'No Price Action'].map((item, i) => (
                                    <span key={i} className="flex items-center gap-2 text-danger/80 line-through decoration-danger/50">
                                    <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-danger/50"></span>
                                        {item}
                                    </span>
                                ))}
                            </div>
                        </div>

                        {/* CTA */}
                        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-2 sm:pt-4">
                            <button className="rounded-full w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-primary to-secondary hover:from-[#005085] hover:to-[#085a8c] text-white font-bold clip-path-slant transition-all shadow-[0_0_20px_rgba(0,97,159,0.3)] flex items-center justify-center gap-2 group text-sm sm:text-base">
                                Discover Our Edge
                                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
                            </button>

                            <button onClick={() => navigate("/courses")} className="rounded-full w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-transparent border border-gray-300 dark:border-gray-700 hover:border-primary/50 text-dark dark:text-light font-medium transition-all flex items-center justify-center gap-2 hover:bg-gray-100/50 dark:hover:bg-gray-800/50 text-sm sm:text-base">
                                <PlayCircle className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
                                Join Elite Training
                            </button>
                        </div>

                    </div>

                    {/* RIGHT VISUAL */}
                    {/*
                        FIX 2: Changed visibility from 'hidden lg:flex' to 'hidden md:flex'
                        This ensures iPad Portrait (md) sees the visual below the text instead of empty space.
                    */}
                    <div className="relative order-2 hidden md:flex items-center justify-center mt-8 lg:mt-0">
                        {/*
                            FIX 3: Adjusted Sizing
                            - lg:w-[420px] (was 520px): Prevents overflow on 1024px screens (iPad Pro Landscape).
                            - xl:w-[520px]: Restores full size on large desktops.
                        */}
                        <div className="relative w-[290px] h-[290px] sm:w-[360px] sm:h-[360px] md:w-[440px] md:h-[440px] lg:w-[420px] lg:h-[420px] xl:w-[520px] xl:h-[520px]">

                            {/* Circles */}
                            <div className="absolute inset-0 border border-gray-200 dark:border-gray-800 rounded-full opacity-60" />
                            <div className="absolute inset-[12%] border border-dashed border-gray-300 dark:border-gray-700 rounded-full opacity-60 animate-[spin_50s_linear_infinite]" />
                            <div className="absolute inset-[24%] border border-gray-200 dark:border-gray-600 rounded-full opacity-40" />

                            {/* Orbit */}
                            <div className="absolute inset-[17%] border border-gray-300 dark:border-gray-800 rounded-full animate-[spin_18s_linear_infinite_reverse]">
                                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 sm:w-4 h-3 sm:h-4 bg-primary rounded-full shadow-[0_0_15px_rgba(0,97,159,.8)]" />
                            </div>

                            {/* Cross Lines */}
                            <svg className="absolute inset-0 w-full h-full text-gray-300 dark:text-gray-700" viewBox="0 0 100 100" fill="none">
                                <line x1="50" y1="0" x2="50" y2="100" stroke="currentColor" strokeWidth="0.5" />
                                <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" strokeWidth="0.5" />
                                <line x1="15" y1="15" x2="85" y2="85" stroke="currentColor" strokeWidth="0.5" />
                                <line x1="85" y1="15" x2="15" y2="85" stroke="currentColor" strokeWidth="0.5" />
                                <circle cx="50" cy="50" r="1" fill="#00619F" />
                            </svg>

                            {/* Forecast Card */}
                            <div className="absolute top-[22%] right-1/2 translate-x-[60%] sm:translate-x-[90%] bg-white/85 dark:bg-bg-dark-2/90 backdrop-blur-xl border border-gray-200 dark:border-gray-700 p-3 sm:p-4 rounded-sm shadow-2xl w-[180px] sm:w-[220px]">
                                <div className="flex items-center justify-between mb-2">
                                    <h4 className="text-primary font-bold uppercase text-[10px] sm:text-xs tracking-widest">
                                        Cycle Forecast
                                    </h4>
                                    <Clock className="w-3 h-3 sm:w-4 sm:h-4 text-gray-400" />
                                </div>
                                <div className="space-y-1">
                                    <div className="flex justify-between text-[11px] sm:text-sm">
                                        <span className="text-gray-500 dark:text-gray-400">Next Pivot</span>
                                        <span className="text-dark dark:text-light font-mono">14 Nov • 09:30</span>
                                    </div>
                                    <div className="flex justify-between text-[11px] sm:text-sm">
                                        <span className="text-gray-500 dark:text-gray-400">Direction</span>
                                        <span className="text-emerald-500 flex items-center gap-1 font-bold">
                                          <TrendingUp className="w-3 h-3" /> Bullish
                                        </span>
                                    </div>
                                    <div className="h-1 w-full bg-gray-200 dark:bg-gray-800 mt-2 rounded-full overflow-hidden">
                                        <div className="h-full bg-primary w-[85%]" />
                                    </div>
                                    <p className="text-[9px] text-right text-gray-400 pt-1">Confidence: 85%</p>
                                </div>
                            </div>

                            {/* Access Card */}
                            <div className="absolute bottom-[8%] left-[5%] sm:left-[-2%] bg-white/85 dark:bg-bg-dark-2/90 backdrop-blur-xl border border-gray-200 dark:border-gray-700 p-3 sm:p-4 rounded-sm shadow-2xl flex items-center gap-3">
                                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-primary/10 flex items-center justify-center border border-primary/30">
                                    <LockOpen className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                                </div>
                                <div>
                                    <p className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 uppercase">
                                        Institutional Access
                                    </p>
                                    <p className="text-sm sm:text-base font-bold text-dark dark:text-light">
                                        Unlocked
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Hero;